<div class="mm-menu" *ngIf="menus && menus.length > 0">
    <div ngbAccordion *ngFor="let menu of menus">
        <div class="py-1" ngbAccordionItem
             [collapsed]="!menu.open"
             *ngIf="hasChildren(menu)">
            <h2 ngbAccordionHeader>
                <button class="btn px-3 py-2 w-100 d-flex align-items-center fs-6"
                        ngbAccordionButton
                        (click)="onMenuClick($event, menu)"
                        [attr.data-identifier]="menu.dataIdentifier">
                    <fa-icon
                        *ngIf="menu.icon"
                        class="icon"
                        [icon]="menu.icon">
                    </fa-icon>
                    <span [ngClass]="{'ps-2': menu.icon}">
                        {{ menu.displayText }}
                    </span>
                </button>
            </h2>
            <div ngbAccordionCollapse>
                <div class="p-0" ngbAccordionBody>
                    <ng-template>
                        <a class="btn text-start w-100"
                           [routerLink]="[menuItem.link]"
                           [routerLinkActive]="['active']"
                           (click)="onMenuItemClick($event, menuItem)"
                           [attr.data-identifier]="menuItem.dataIdentifier"
                           *ngFor="let menuItem of menu.children">
                            {{ menuItem.displayText }}
                            <fa-icon
                                *ngIf="isFlagged(menuItem.displayText)"
                                [icon]="faCircleExclamation"
                                class="flagged-icon">
                            </fa-icon>
                        </a>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="py-1"
             *ngIf="!hasChildren(menu)">
            <a class="btn px-3 py-2 text-start w-100 d-flex align-items-center fs-6"
               [routerLink]="[menu.link]"
               [routerLinkActive]="['active']"
               (click)="onMenuClick($event, menu)">
                <fa-icon
                    *ngIf="menu.icon"
                    class="icon"
                    [icon]="menu.icon">
                </fa-icon>
                <span [ngClass]="{'ps-2': menu.icon}">
                    {{ menu.displayText }}
                </span>
            </a>
        </div>
    </div>
</div>
